import { IDashboardTranslations } from '..';
import common from '../common/en';

const dashboard: IDashboardTranslations = {
  ...common,
  welcome: 'Welcome',
  whatsup: 'What are you up to today?',
  create_event: 'Create event',
  create_event_description: 'I want to create a new event',
  create_device: 'Create device',
  create_device_description: 'I want to create a new device',
  events: 'Events',
  manage_events: 'I want to manage events',
  devices: 'Devices',
  manage_devices: 'I want to manage devices',
  categories: 'Categories',
  manage_categories: 'I want to manage device categories',
  models: 'Models',
  manage_models: 'I want to manage device models',
  download_subscribed_emails: 'I want to download subscribed emails'
};

export default dashboard;
